module.exports = __webpack_public_path__ + "images/proxy.26b4.png";